import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b77c28be"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onSubmit"];
const _hoisted_2 = { class: "input-group" };
const _hoisted_3 = { class: "input-group" };
const _hoisted_4 = { class: "label_zone" };
const _hoisted_5 = { class: "checkbox-group" };
const _hoisted_6 = { class: "button_box" };
const _hoisted_7 = {
    type: "submit",
    class: "act-btn"
};
import { reactive } from 'vue';
import TextWithLabel from '@/materials/molecules/TextWithLabel.vue';
import InvalidField from '@/materials/atoms/InvalidField.vue';
import Checkbox from '@/materials/atoms/CheckBox.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        apiAccessTokenForm: null,
        apiRoles: null,
        errors: null
    },
    emits: ["submitted"],
    setup(__props, { emit }) {
        const props = __props;
        const { MYPAGE_API_MANAGEMENT, format } = useMessage();
        const state = reactive({
            apiAccessTokenForm: props.apiAccessTokenForm,
        });
        const onChangeRole = (checked, code) => __awaiter(this, void 0, void 0, function* () {
            if (checked) {
                state.apiAccessTokenForm.roles.push(code);
                return;
            }
            state.apiAccessTokenForm.roles = state.apiAccessTokenForm.roles.filter((r) => r !== code);
        });
        const onSubmit = () => __awaiter(this, void 0, void 0, function* () { return emit('submitted', state.apiAccessTokenForm); });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d;
            return (_openBlock(), _createElementBlock("form", {
                class: "form",
                onSubmit: _withModifiers(onSubmit, ["prevent"])
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(TextWithLabel, {
                        reference: _unref(state).apiAccessTokenForm.label,
                        "onUpdate:reference": _cache[0] || (_cache[0] = ($event) => ((_unref(state).apiAccessTokenForm.label) = $event)),
                        "default-value": _unref(state).apiAccessTokenForm.label,
                        label: _unref(format)(_unref(MYPAGE_API_MANAGEMENT).INPUT_LABEL_LABEL_NAME),
                        "has-error": !!((_a = props.errors) === null || _a === void 0 ? void 0 : _a.label),
                        "invalid-message": (_b = props.errors) === null || _b === void 0 ? void 0 : _b.label
                    }, null, 8, ["reference", "default-value", "label", "has-error", "invalid-message"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("label", null, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).INPUT_LABEL_ROLES)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.apiRoles, (apiRole) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: apiRole.code
                            }, [
                                _createVNode(Checkbox, {
                                    id: `roles-${apiRole.code}`,
                                    class: "box",
                                    label: _unref(format)(apiRole.labels),
                                    "is-init-check": _unref(state).apiAccessTokenForm.roles.includes(apiRole.code),
                                    onChange: (checked) => onChangeRole(checked, apiRole.code)
                                }, null, 8, ["id", "label", "is-init-check", "onChange"])
                            ]));
                        }), 128))
                    ]),
                    _createVNode(InvalidField, {
                        "is-invalid": !!((_c = props.errors) === null || _c === void 0 ? void 0 : _c.roles),
                        message: ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.roles) || ''
                    }, null, 8, ["is-invalid", "message"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("button", _hoisted_7, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_SAVE)), 1)
                ])
            ], 40, _hoisted_1));
        };
    }
});
